// Known application names for transfer requests.
// Add new entries here when onboarding another application.
export const APPLICATIONS = [
  { id: 'Stabletrust', name: 'Stabletrust' },
  { id: 'BNB', name: 'BNB' },
  { id: 'CUSD', name: 'CUSD' },
  { id: 'SDK', name: 'SDK' },
  { id: 'YieldShield', name: 'YieldShield' },
];

/** Shown when applicationName is missing or not in APPLICATIONS. */
export const UNKNOWN_APPLICATION = 'Unknown';

/**
 * Resolve the application name from a request document.
 * Prefers the DB field `applicationName`, with legacy fallbacks.
 * Missing or unrecognized names resolve to Unknown.
 */
export const getRequestApplication = (request) => {
  const raw =
    request?.applicationName ||
    request?.application ||
    request?.app ||
    '';
  const trimmed = typeof raw === 'string' ? raw.trim() : '';
  if (!trimmed) return UNKNOWN_APPLICATION;

  const known = APPLICATIONS.find(
    (app) => app.id.toLowerCase() === trimmed.toLowerCase()
  );
  return known ? known.id : UNKNOWN_APPLICATION;
};

export const getApplicationDisplayName = (nameOrId) => {
  if (!nameOrId) return UNKNOWN_APPLICATION;
  const found = APPLICATIONS.find(
    (app) => app.id.toLowerCase() === String(nameOrId).toLowerCase()
  );
  return found?.name || UNKNOWN_APPLICATION;
};

/** Options for admin access-rule selects (includes "all"). */
export const getApplicationSelectOptions = (allValue = '-') => [
  { value: allValue, label: 'All applications' },
  ...APPLICATIONS.map((app) => ({ value: app.id, label: app.name })),
];
